
import React, { useContext, useState, useEffect, useRef } from 'react';
import {
    Input,
    Button,
    Select,
    DatePicker,
    TimeInput,    
    FormItem,
    FormContainer,
    Alert,
    Spinner,
    Radio,
    Dialog,
} from 'components/ui'

import { Field, Form, Formik } from 'formik'
import CreatableSelect from 'react-select/creatable'
import * as Yup from 'yup'
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import dateFormat from 'dateformat';
import { useAuth } from "../../shared/hooks/auth-hook";

     
    const MeetingMedium = [
      { value: 'skype', label: 'Skype' },
      { value: 'zoom', label: 'Zoom' },
      { value: 'meet', label: 'Meet' },
      { value: 'phone', label: 'Phone' },
      { value: 'office', label: 'Office' },
    ]

const validationSchema = Yup.object().shape({
    
    clientName: Yup.string().required('Please Select Client Name.'),
    projectName: Yup.string().required('Please Select Project Name.'),
    estimateOrAssignment: Yup.boolean().required('Please select one!'),
    estimateName: Yup.string().when('estimateOrAssignment', {
        is: true,
        then: Yup.string().required('Please Select Estimate.')
      }),
    assignmentName: Yup.string().when('estimateOrAssignment', {
        is: false,
        then: Yup.string().required('Please Select Assignment.')
    }),  
    meetingTitle: Yup.string().required('Please Enter Meeting Title.'),
    meetingDuration: Yup.string().required('Please Enter Meeting Duration In Minutes.'),
    meetingPersons: Yup.array().min(1, 'At least one is selected!'),
    meetingMedium: Yup.string().required('Please Select Medium.'),
    date: Yup.date().required('Date Required!').nullable(),
    time: Yup.date().required('Time Required!').nullable(),
})

const NewMeetingForm = (props) => {
    const auth = useContext(AuthContext);
    const formRef = useRef();
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const [optionsClientNames, setOptionClientNames] = useState([]);
    const [selectedClientId, setSelectedClientId] = useState("");
    const [optionsProjects, setOptionsProjects] = useState([{ label: "Select", value: "" }]);
    const [selectedProjectId, setSelectedProjectId] = useState("");
    const [optionsAssignments, setOptionsAssignments] = useState([{ label: "Select", value: "" }]);
    const [optionsEstimates, setOptionsEstimates] = useState([{ label: "Select", value: "" }]);
    const [optionsResourceNames, setOptionsResourceNames] = useState([]);
    const [serverErrorMessage, setServerErrorMessage ] = useState("");
    const { userName, userLogin, userEmail } = useAuth();
    const [isEstimate, setIsEstimate ] = useState(false);
    const [dialogIsOpen, setIsOpen] = useState(false);

    const onDialogClose = (e) => {
        setIsOpen(false)
    }
    
    const handleEstimateOrAssignmentChange = (value) => {        
        setIsEstimate(value);        
    };

    const handleClientNameChange = (clientId) => {        
        setSelectedClientId(clientId);
        fetchProjectsBYClientId(clientId);
    };

    const handleProjectNameChange = (projectId) => {        
        setSelectedProjectId(projectId);
        fetchAssignmentsBYClientIdProjectId(projectId);
        fetchEstimatessBYClientIdProjectId(projectId);
    };  

    const fetchAssignmentsBYClientIdProjectId = async (projectId) => {
        formRef.current.values.assignmentName="";   
        setOptionsAssignments([{ label: "Select", value: "" }]); 
        if (projectId) {
            try {
            const responseData = await sendRequest(
                `${process.env.REACT_APP_ERP_URL}/getAssignments.php?token=AxOCwiaWF0IjoxNjgwMjQzMDE4f&client_id=${selectedClientId}&project_id=${projectId}`
            );
            const getAssignmentsItmes = responseData.assignments;
            const options = [{ label: "Select", value: "" }];
            if(responseData.status==='success')
            {
                if (getAssignmentsItmes && getAssignmentsItmes.length > 0) {
                    getAssignmentsItmes.map((element) => {
                        options.push({ label: element.assignment_title, value: element.assignment_id });
                        return null;
                    
                    });
                    setOptionsAssignments(options);
                    
                }
            }
            else
            {
                setOptionsAssignments([{ label: "Select", value: "" }]); 
            }
            } catch (err) {}
        } 
    };  

    const fetchEstimatessBYClientIdProjectId = async (projectId) => {
        formRef.current.values.estimateName="";   
        setOptionsEstimates([{ label: "Select", value: "" }]); 
        if (projectId) {
            try {
            const responseData = await sendRequest(
                `${process.env.REACT_APP_ERP_URL}/getEstimates.php?token=AxOCwiaWF0IjoxNjgwMjQzMDE4f&client_id=${selectedClientId}&project_id=${projectId}`
            );
            const getEstimatesItmes = responseData.estimates;
            const options = [{ label: "Select", value: "" }];
            if(responseData.status==='success')
            {
                if (getEstimatesItmes && getEstimatesItmes.length > 0) {
                    getEstimatesItmes.map((element) => {
                        options.push({ label: element.estimate_title, value: element.estimate_id });
                        return null;
                    
                    });
                    setOptionsEstimates(options);
                    
                }
            }
            else
            {
                setOptionsEstimates([{ label: "Select", value: "" }]); 
            }
            } catch (err) {}
        } 
    };  

    const fetchProjectsBYClientId = async (clientId) => {
        formRef.current.values.projectName="";   
        formRef.current.values.assignmentName=""; 
        setOptionsProjects([{ label: "Select", value: "" }]); 
        setOptionsAssignments([{ label: "Select", value: "" }]);
        if (clientId) {
            try {
                const responseData = await sendRequest(
                    `${process.env.REACT_APP_ERP_URL}/getProjects.php?token=AxOCwiaWF0IjoxNjgwMjQzMDE4f&client_id=${clientId}`
                );
                const getProjectsItmes = responseData.projects;
                const options = [{ label: "Select", value: "" }];
                if(responseData.status==='success')
                {
                    if (getProjectsItmes && getProjectsItmes.length > 0) {
                        getProjectsItmes.map((element) => {
                            options.push({ label: element.project_title, value: element.project_id });
                            return null;
                        
                        });
                        setOptionsProjects(options);
                        
                    }
                }
            
            } catch (err) {}
        } 
    };  

    useEffect(() => {        
        const fetchClientNames = async () => {
          try {
            const responseData = await sendRequest(
              `${process.env.REACT_APP_ERP_URL}/getClients.php?token=AxOCwiaWF0IjoxNjgwMjQzMDE4f`
            );
            const options = [{ label: "Select", value: "" }];
            if(responseData.status==='success')
            {
                const fetchClientNames = responseData.clients;
                
                if (fetchClientNames.length > 0) {
                    fetchClientNames.map((element) => {
                    options.push({ label: element.client_name, value: element.client_id });
                    return null;
                });
                setOptionClientNames(options);
                }
            }
            
          } catch (err) {
            //console.log(err);
          }
        };
        fetchClientNames();

        const fetchResourceNames = async () => {
            try {
              const responseData = await sendRequest(
                `${process.env.REACT_APP_ERP_URL}/getResources.php?token=AxOCwiaWF0IjoxNjgwMjQzMDE4f`
              );
              const options = [{ label: "Select", value: "" }];
              if(responseData.status==='success')
              {
                  const fetchResourceNames = responseData.resources;
                  
                  if (fetchResourceNames.length > 0) {
                    fetchResourceNames.map((element) => {
                      options.push({ label: element.resource_name, value: element.resource_id });
                      return null;
                  });
                  setOptionsResourceNames(options);
                  }
              }
              
            } catch (err) {
              //console.log(err);
            }
          };
        fetchResourceNames();
      }, [sendRequest, auth.userId]);

    return (
        <div>
            {isLoading && (
                <div className="center flex items-center">                
                    <Spinner size="3.25rem" />
                </div>
            )}
            {(serverErrorMessage) && (
                <Dialog
                isOpen={dialogIsOpen}
                onClose={onDialogClose}
                onRequestClose={onDialogClose}
            >
                <Alert className="mb-4" type="danger" showIcon>
                    {serverErrorMessage}
                </Alert>
            </Dialog>
                
            )}
            <Formik
                enableReinitialize
                initialValues={{
                    clientName: '',
                    projectName: '',
                    estimateOrAssignment: 0,
                    estimateName: '',
                    assignmentName: '',
                    meetingTitle: '',
                    meetingDuration: '',
                    meetingPersons: [],
                    meetingMedium: '',
                    date: null,
                    time: null,
                }}
                validationSchema={validationSchema}
                onSubmit={ async (values, { setSubmitting }) => {
                    //console.log('values', values)
                    //console.log(userName);
                    const selectedClientname = optionsClientNames.filter(cname => cname.value === values.clientName);
                    const selectedProject = optionsProjects.filter(pname => pname.value === values.projectName);
                    const selectedAssignment = optionsAssignments.filter(aname => aname.value === values.assignmentName);
                    const selectedEstimate = optionsEstimates.filter(ename => ename.value === values.estimateName);
                    const personIdArray= [];
                    const personNameArray = [];
                    const CurrentDate = new Date();
                    values.meetingPersons.map((element) => {
                        personIdArray.push(element.value);
                        personNameArray.push(element.label);
                    
                    });
                    const method = 'POST';
                    const body = JSON.stringify({
                        client_id: values.clientName,
                        client_name: selectedClientname[0].label,
                        project_id: values.projectName,
                        project_title: selectedProject[0].label,
                        assignment_id: values.assignmentName ? values.assignmentName : 0,
                        assignment_title: selectedAssignment.length ? selectedAssignment[0].label : "" ,
                        is_estimate: values.estimateOrAssignment,
                        estimate_id: values.estimateName ? values.estimateName : 0,
                        estimate_title: selectedEstimate.length ? selectedEstimate[0].label : "",
                        meeting_title: values.meetingTitle,
                        meeting_duration: values.meetingDuration,
                        person_id: personIdArray,
                        person_name: personNameArray,
                        meeting_medium: values.meetingMedium,
                        meeting_date_time: dateFormat(values.date, "yyyy-mm-dd")+" "+dateFormat(values.time, "HH:MM"),
                        created_by: userName,
                        created_by_date_time: dateFormat(CurrentDate, "yyyy-mm-dd HH:MM"),
                        updated_by: userName,
                        updated_by_date_time: dateFormat(CurrentDate, "yyyy-mm-dd HH:MM"),
                        });
                    const headers = {
                        
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + auth.token,
                        
                    };
                    //console.log(dateFormat(values.date, "yyyy-mm-dd")+" "+dateFormat(values.time, "HH:MM"));
                    //console.log(body);
                    try {
                        
                        /*const httpAbortCtrl = new AbortController();
                        const response = await fetch(process.env.REACT_APP_BACKEND_URL + '/meetings', {
                            method,
                            body,
                            headers,
                            signal: httpAbortCtrl.signal,
                            //credentials: 'include',
                            //mode: 'no-cors'
                          });
                          const responseData = await response.json();*/

                          const responseData = await sendRequest(
                            `${process.env.REACT_APP_BACKEND_URL}/meetings`,
                            method,
                            body,
                            headers,
                          );
                  
                          
                        
                            if(responseData.success)
                            {
                                setSubmitting(false)  
                                props.onDrawerClose();
                                props.fetchMeetings(1);
                                props.showMeetingAddedAlert();
                            }
                            else
                            {
                                setServerErrorMessage(responseData.message);
                                setIsOpen(true);
                            }
                      } catch (err) {
                            console.log(err);
                      }
                    
                }}
                innerRef={formRef}
            >
                {({ values, touched, errors, resetForm }) => (
                    <Form id='meeting-form'>
                        <FormContainer>
                            <FormItem
                                label="Client Name"
                                asterisk
                                invalid={errors.clientName && touched.clientName}
                                errorMessage={errors.clientName}
                            >
                                <Field name="clientName">
                                    {({ field, form }) => (
                                        <Select
                                            field={field}
                                            form={form}
                                            options={optionsClientNames}
                                            value={optionsClientNames.filter(
                                                (option) =>
                                                    option.value ===
                                                    values.clientName
                                            )}
                                            onChange={(option) => {
                                                    form.setFieldValue(
                                                        field.name,
                                                        option.value
                                                    );
                                                    handleClientNameChange(option.value);
                                                }
                                            }
                                        />
                                    )}
                                </Field>
                            </FormItem>

                            <FormItem
                                label="Project Name"
                                asterisk
                                invalid={errors.projectName && touched.projectName}
                                errorMessage={errors.projectName}
                            >
                                <Field name="projectName">
                                    {({ field, form }) => (
                                        <Select
                                            field={field}
                                            form={form}
                                            options={optionsProjects}
                                            value={optionsProjects.filter(
                                                (option) =>
                                                    option.value ===
                                                    values.projectName
                                            )}
                                            onChange={(option) => {
                                                    form.setFieldValue(
                                                        field.name,
                                                        option.value
                                                    )
                                                    handleProjectNameChange(option.value);
                                                }
                                                
                                            }
                                        />
                                    )}
                                </Field>
                            </FormItem>
                                            
                            <FormItem
                                label="Assignment OR Estimate"
                                asterisk
                                invalid={errors.estimateOrAssignment && touched.estimateOrAssignment}
                                errorMessage={errors.estimateOrAssignment}
                            >
                                <Field name="estimateOrAssignment">
                                    {({ field, form }) => (
                                        <Radio.Group
                                            value={values.estimateOrAssignment}
                                            onChange={(val) => {
                                                    form.setFieldValue(
                                                        field.name,
                                                        val
                                                    );
                                                    handleEstimateOrAssignmentChange(val);
                                                }
                                            }
                                        >
                                            <Radio value={0}>Assignment</Radio>
                                            <Radio value={1}>Estimate</Radio>
                                            
                                        </Radio.Group>
                                    )}
                                </Field>
                            </FormItem>
                            {isEstimate ? (
                            <FormItem
                                label="Estimate Name"
                                asterisk
                                invalid={errors.estimateName && touched.estimateName}
                                errorMessage={errors.estimateName}
                            >
                                <Field name="estimateName">
                                    {({ field, form }) => (
                                        <Select
                                            field={field}
                                            form={form}
                                            options={optionsEstimates}
                                            value={optionsEstimates.filter(
                                                (option) =>
                                                    option.value ===
                                                    values.estimateName
                                            )}
                                            onChange={(option) =>
                                                form.setFieldValue(
                                                    field.name,
                                                    option.value
                                                )
                                            }
                                        />
                                    )}
                                </Field>
                            </FormItem>
                            ) : (

                            <FormItem
                                label="Assignment Name"
                                asterisk
                                invalid={errors.assignmentName && touched.assignmentName}
                                errorMessage={errors.assignmentName}
                            >
                                <Field name="assignmentName">
                                    {({ field, form }) => (
                                        <Select
                                            field={field}
                                            form={form}
                                            options={optionsAssignments}
                                            value={optionsAssignments.filter(
                                                (option) =>
                                                    option.value ===
                                                    values.assignmentName
                                            )}
                                            onChange={(option) =>
                                                form.setFieldValue(
                                                    field.name,
                                                    option.value
                                                )
                                            }
                                        />
                                    )}
                                </Field>
                            </FormItem>
                            )}
                            <FormItem
                                label="Meeting Objective / Title"
                                asterisk
                                invalid={errors.meetingTitle && touched.meetingTitle}
                                errorMessage={errors.meetingTitle}
                            >
                                <Field
                                    type="text"
                                    name="meetingTitle"
                                    placeholder="Meeting Objective / Title"
                                    component={Input}
                                />
                            </FormItem>

                            <FormItem
                                label="Meeting Duration in minutes"
                                asterisk
                                invalid={errors.meetingDuration && touched.meetingDuration}
                                errorMessage={errors.meetingDuration}
                            >
                                <Field
                                    type="number"
                                    name="meetingDuration"
                                    placeholder="Meeting Duration in minutes"
                                    component={Input}
                                />
                            </FormItem>

                            <FormItem
                                label="Meeting person"
                                asterisk
                                invalid={Boolean(
                                    errors.meetingPersons &&
                                        touched.meetingPersons
                                )}
                                errorMessage={errors.meetingPersons}
                            >
                                <Field name="meetingPersons">
                                    {({ field, form }) => (
                                        <Select
                                            componentAs={CreatableSelect}
                                            isMulti
                                            field={field}
                                            form={form}
                                            options={optionsResourceNames}
                                            value={values.optionsResourceNames}
                                            onChange={(option) => {
                                                form.setFieldValue(
                                                    field.name,
                                                    option
                                                )
                                            }}
                                        />
                                    )}
                                </Field>
                            </FormItem>

                            <FormItem
                                label="Medium"
                                asterisk
                                invalid={errors.meetingMedium && touched.meetingMedium}
                                errorMessage={errors.meetingMedium}
                            >
                                <Field name="meetingMedium">
                                    {({ field, form }) => (
                                        <Select
                                            field={field}
                                            form={form}
                                            options={MeetingMedium}
                                            value={MeetingMedium.filter(
                                                (option) =>
                                                    option.value ===
                                                    values.meetingMedium
                                            )}
                                            onChange={(option) =>
                                                form.setFieldValue(
                                                    field.name,
                                                    option.value
                                                )
                                            }
                                        />
                                    )}
                                </Field>
                            </FormItem>

                            <FormItem
                                label="Meeting Date"
                                asterisk
                                invalid={errors.date && touched.date}
                                errorMessage={errors.date}
                            >
                                <Field name="date" placeholder="Pick a date">
                                    {({ field, form }) => (
                                        <DatePicker
                                            field={field}
                                            form={form}
                                            value={field.value}
                                            onChange={(date) => {
                                                form.setFieldValue(
                                                    field.name,
                                                    date
                                                )
                                            }}
                                        />
                                    )}
                                </Field>
                            </FormItem>
                            <FormItem
                                label="Meeting Time"
                                asterisk
                                invalid={errors.time && touched.time}
                                errorMessage={errors.time}
                            >
                                <Field name="time" placeholder="Time">
                                    {({ field, form }) => (
                                        <TimeInput
                                            format="12"
                                            field={field}
                                            form={form}
                                            value={field.value}
                                            onChange={(time) => {
                                                form.setFieldValue(
                                                    field.name,
                                                    time
                                                )
                                            }}
                                        />
                                    )}
                                </Field>
                            </FormItem>
                            
                        </FormContainer>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default NewMeetingForm

